/**
 * 描述：弹出框高度修正指令
 * 日期：2017-10-25
 * 作者：Bai.Zhiming
 */
'use strict';
angular.module('modalDialogHeightFixModule', []).
directive('modalDialog', ["$timeout", function($timeout) {
    return {
        restrict: 'C',
        replace: false,
        link: function(scope, $elem, $attrs) {
            init();
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                $timeout(function() {
                    var htmlHight = $("body")[0].offsetHeight;
                    var modalHeight = $elem[0].offsetHeight;
                    if ($elem.find(".publicModal .body").eq(0)) {
                        var bodyHeight = $elem.find(".publicModal .body")[0].offsetHeight;
                        var moreThan = modalHeight - htmlHight;
                        if (moreThan > 0) {
                            if ((bodyHeight - moreThan) > 50) {
                                $elem.find(".publicModal .body").eq(0).height(bodyHeight - moreThan);
                                $elem.height(modalHeight - moreThan);
                                $elem.find(".publicModal .body").eq(0).css({ "overflow-y": 'auto', "overflow-x": 'hidden' });
                            } else {
                                var newModalBody = bodyHeight - 50 > 0 ? 50 : bodyHeight;
                                $elem.find(".publicModal .body").eq(0).height(newModalBody);
                                $elem.height(modalHeight - (bodyHeight - newModalBody));
                                $elem.find(".publicModal .body").eq(0).css({ "overflow-y": 'auto', "overflow-x": 'hidden' });
                            };
                        };
                        var oft = (htmlHight - $elem.height()) / 2;
                        oft = oft > 0 ? oft : 0;
                        $elem.animate({
                            top: oft,
                            opacity: 1
                        }, 100);
                    } else {
                        init();
                    };
                }, 100);
            }
        }
    };
}]);